// app/javascript/controllers/utility_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  sendRequest(url, method, data, csrfToken) {
    return fetch(url, {
      method: method,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify(data)
    });
  }
  
  toggleAddons(e) {
    let shouldReveal = e.type === 'mouseover';
    this.element.querySelectorAll('.addons').forEach((element) => {
      element.classList.toggle('hidden', !shouldReveal);
    })
  }

  revealFlashMessage(message) {
    const flashMessage = document.createElement("div");
    flashMessage.className = "mobile-flash animate__animated animate__fadeInDown";
    flashMessage.dataset.controller = "mobile-flash";
    const body = document.createElement("div");
    body.className = "mobile-flash__body";
    body.textContent = message;
    flashMessage.append(body);
    document.body.prepend(flashMessage);
  }
}
